// components/chakra/NavbarWithCallToAction/NavbarWithCallToAction.tsx

import { useState } from "react";
import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  Link,
  useDisclosure,
  useColorMode,
} from "@chakra-ui/react";
import { Logo } from "../../../Logo";

import { Link as RouterLink } from "react-router-dom";
import { LoginWithSmsModal } from "../../../pages/authentication";
import { brandConfig, getColor } from "../../../brandConfig";
import ListBuildingModal from "../../ListBuildingModal";

export const NavbarWithCallToAction = () => {
  const { colorMode } = useColorMode();

  const { isOpen: isLoginOpen, onClose: onLoginClose } = useDisclosure();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLoginSuccess = () => {
    onLoginClose();
    window.location.reload();
  };

  return (
    <Box
        position="sticky"
        top={0}
        left={0}
        right={0}
        zIndex="sticky"
        bg="rgba(10, 10, 15, 0.8)"
        backdropFilter="blur(20px)"
        borderBottom="1px solid"
        borderColor="rgba(255, 255, 255, 0.08)"
        boxShadow="0 4px 30px rgba(0, 0, 0, 0.3)"
        margin={0}
        padding={0}
        width="100%"
        overflow="hidden"
      >
        <Container maxW="7xl" position="relative" zIndex={1} px={{ base: 3, md: 6 }} py={0}>
          <Flex
            py={0}
            my={0}
            maxH="60px"
            align="center"
            justify="space-between"
            gap={{ base: 2, md: 4 }}
            width="100%"
          >
            <Link
              as={RouterLink}
              to="/"
              aria-label={`${brandConfig.siteName} home`}
              style={{ padding: 0, margin: 0 }}
              flexShrink={0}
            >
              <Logo />
            </Link>

          <HStack spacing={{ base: 1, md: 4 }} flexShrink={0}>
            {/* Updates Button */}
            <Button
              variant="ghost"
              size={{ base: "sm", md: "md" }}
              onClick={() => setIsModalOpen(true)}
              color={getColor("primary", colorMode)}
              fontWeight="600"
              _hover={{
                color: getColor("secondary", colorMode),
                bg: getColor("background.overlay", colorMode),
                transform: "translateY(-2px)",
              }}
              transition="all 0.2s ease"
              px={{ base: 2, md: 4 }}
              fontSize={{ base: "sm", md: "md" }}
            >
              Updates
            </Button>

          </HStack>
        </Flex>
      </Container>

      {/* SMS Login Modal */}
      <LoginWithSmsModal
        isOpen={isLoginOpen}
        onClose={onLoginClose}
        onLoginSuccess={handleLoginSuccess}
      />

      {/* List Building Modal */}
      <ListBuildingModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </Box>
  );
};